import {connect} from "react-redux";
import SubleaguesChat from "./SubleagueChat";
import {sendMessage, fetchMessages} from "./subleagueChatActions";

const mapStateToProps = (state, ownProps) => {
    let chat = state.subleagueChat;

    if (chat.subleagueId !== ownProps.subleagueId) {
        chat = {show: false}
    }

    return {
        chat,
        ...ownProps
    };
};

const mapDispatchToProps = (dispatch, {subleagueId}) => {
    return {
        load: () => dispatch(fetchMessages(subleagueId)),
        onSendMessage: message => dispatch(sendMessage(subleagueId, message)),
    }
};

const SubleaguesChatContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(SubleaguesChat);

export default SubleaguesChatContainer